import { useState } from 'react'

import Styles from 'utils/styles.module.scss'
import { SuggestionReviewApprovedRealtimeNotificationModalProps } from './Types'
import { getInitials } from 'utils'
import { LazyComponentWrapper } from 'components/LazyComponentWrapper/LazyComponentWrapper'
import { lazyRetry } from 'utils/lazyRetry'
import { Suggestion } from 'api/clients/SuggestionsClient'
import WorkflowMomentModal from 'components/WorkflowMomentModal/WorkflowMomentModal'
import { Modal } from 'almanac-ui/Modal'

const SuggestionStatusModal = lazyRetry(() => import('components/SuggestionStatusModal/SuggestionStatusModal'))

const SuggestionReviewApprovedRealtimeNotificationModal = ({
  visible,
  setVisible,
  onClose,
  suggestion,
  review,
}: SuggestionReviewApprovedRealtimeNotificationModalProps) => {
  const { suggester } = suggestion
  const { reviewer } = review
  const [showSuggestionsStatusModal, setShowSuggestionsStatusModal] = useState(false)

  const suggesterName = suggester.display_name
  const reviewerName = reviewer.display_name

  const onViewStatusButtonClick = () => {
    setShowSuggestionsStatusModal(true)
  }

  const statusModal = (suggestion: Suggestion) =>
    showSuggestionsStatusModal ? (
      <LazyComponentWrapper
        component={
          <SuggestionStatusModal
            visible={showSuggestionsStatusModal}
            setVisible={setShowSuggestionsStatusModal}
            suggestion={suggestion}
          />
        }
      />
    ) : null

  return (
    <>
      <WorkflowMomentModal
        visible={visible}
        setVisible={setVisible}
        leftAvatar={{ url: suggester.avatar_url || undefined, initials: getInitials(suggester.display_name) }}
        leftAvatarRingColor={Styles.orange50}
        rightAvatar={{ url: reviewer.avatar_url || undefined, initials: getInitials(reviewer.display_name) }}
        rightAvatarRingColor={Styles.green50}
        nextActor="left"
        title={`${reviewerName} approved ${suggesterName}'s suggested changes.`}
        description="You can review their note in the view status window."
        primaryCta={
          <Modal.FooterButton size="lg" onPress={onViewStatusButtonClick}>
            View status
          </Modal.FooterButton>
        }
      />
      {statusModal(suggestion)}
    </>
  )
}

export { SuggestionReviewApprovedRealtimeNotificationModal }
